import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {API_URL} from '../env';

@Injectable()
export class GameSessionsApiService {

  result:any;

  constructor(private http: HttpClient) {
  }

  private static _handleError(err: HttpErrorResponse | any) {
    return Observable.throw(err.message || 'Error: Unable to complete request.');
  }

  getResult() {
    return this.result;
  }

  getPrices() {
    return this.http.get('https://min-api.cryptocompare.com/data/pricemulti?fsyms=BTC&tsyms=USD')
      .map(result => this.result = result);
  }

  getGameSessions(): Observable<any> {
    return this.http
      .get(`${API_URL}/game_session`)
      .catch(GameSessionsApiService._handleError);
  }

  getFilteredGameSessions(inValues:Array<string>): Observable<any> {
    console.log("-- ***** --"+inValues);
    return this.http
      .get(`${API_URL}/game_filtered_session`+"?inp="+inValues)
      .catch(GameSessionsApiService._handleError);
  }

  getGameLeaders(): Observable<any> {
    return this.http
      .get(`${API_URL}/game_leaders`)         // game_leaders
      .catch(GameSessionsApiService._handleError);
  }

}

